import { NgModule } from '@angular/core';

import { MzButtonDirective } from './button.directive';

@NgModule({
  declarations: [MzButtonDirective],
  exports: [MzButtonDirective],
})
export class MzButtonModule { }
